export const  GET_TERM_AND_CONDITION = "GET_TERM_AND_CONDITION"
export const GET_TERM_AND_CONDITION_SUCCESS = "GET_TERM_AND_CONDITION_SUCCESS"
export const GET_TERM_AND_CONDITION_FAILURE = "GET_TERM_AND_CONDITION_FAILURE"